import styled, { space, typography } from '@styled'
import { Col } from 'react-bootstrap'

export const StyledCol = styled(
  ({
    /* eslint-disable no-unused-vars */
    p,
    px,
    py,
    pt,
    pb,
    pl,
    pr,
    m,
    mx,
    my,
    mt,
    mb,
    ml,
    mr,
    textAlign,
    width,
    height,
    display,
    justifyContent,
    alignItems,
    ...rest
    /* eslint-enable no-unused-vars */
  }) => <Col {...rest} />
)`
  ${space};
  ${typography};
`
